import * as React from 'react';
//@ts-ignore
import {useState, useMemo, useCallback, useRef, useEffect} from 'react';
import MapBlock from "./components/Map/mapBlock";
import useContentful from "./components/Contenfull/useContentful";
import {IContinents, ICoordinate, ICountries} from "./types/types";
import {BrowserRouter, Route, Router, Routes} from "react-router-dom";

function App() {
    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)
    const [hoverInfo, setHoverInfo] = useState<any>(null);
    const [coordinate, setCoordinate] = useState<ICoordinate>({
        longitude: null,
        latitude: null,
        name: null,
        offices: undefined
    })
    const [continentMap, setContinentMap] = useState<null | string>(null)
    const [zoom, setZoom] = useState(1.9);
    const [continentZoom, setContinentZoom] = useState(0);

    const {getContinents, getCountries} = useContentful();
    const [continents, setContinents] = useState<IContinents[]>([]);
    const [countries, setCountries] = useState<ICountries[]>([]);
    const [selected,setSelected] = useState<string>('')
    const pinCountry = continents?.find(item => item?.continent === selected)?.country;

    useEffect(() => {
        getContinents().then(res => setContinents(res as any))
        getCountries().then(res => setCountries(res as any))

    }, [])

  return (
    <BrowserRouter>
    <Routes>
        <Route path='*' element={<MapBlock isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} hoverInfo={hoverInfo}
                                           setHoverInfo={setHoverInfo}
                                           continentMap={continentMap} setContinentMap={setContinentMap}
                                           setCoordinate={setCoordinate}
                                           zoom={zoom}
                                           setZoom={setZoom}
                                           continentZoom={continentZoom}
                                           setContinentZoom={setContinentZoom}
                                           coordinate={coordinate}
                                           continents={continents}
                                           countries={countries}
                                           selected={selected}
                                           setSelected={setSelected}
                                           pinCountry={pinCountry}

        />} />
        {/*<div className={'mobileBlock'}>*/}
        {/*    <MobileBlock continents={continents} countries={countries} />*/}
        {/*</div>*/}
    </Routes>
    </BrowserRouter>
  );
}

export default App;
